import React, { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import styles from "./styles.module.scss";
import { cls } from "app/utils";

type CountdownTimerProps = {
  expiresAt: string | Date;
  runningLabel?: string;
  expiredLabel?: string;
  onExpire?: () => void;
  className?: string;
};

export default function CountdownTimer(props: CountdownTimerProps) {
  const {
    expiresAt,
    runningLabel = "Pending",
    expiredLabel = "Expired",
    onExpire,
    className
  } = props;

  const { t } = useTranslation();
  const [countdown, setCountdown] = useState("");
  const [isExpired, setIsExpired] = useState(false);

  useEffect(() => {
    if (!expiresAt) {
      return undefined;
    }

    const updateCountdown = () => {
      const now = new Date();
      const target = new Date(expiresAt);
      const timeDiff = target.getTime() - now.getTime();

      if (timeDiff <= 0) {
        setCountdown("");
        setIsExpired(true);
        if (onExpire) {
          onExpire();
        }
        return;
      }

      const minutes = Math.floor(timeDiff / (1000 * 60));
      const seconds = Math.floor((timeDiff % (1000 * 60)) / 1000);

      setCountdown(`${minutes}:${seconds.toString().padStart(2, "0")}`);
      setIsExpired(false);
    };

    updateCountdown();
    const interval = setInterval(updateCountdown, 1000);

    return () => clearInterval(interval);
  }, [expiresAt, onExpire]);

  if (isExpired) {
    return (
      <span className={cls(styles.payment_status, styles.expires_at_status, className)}>
        {t(expiredLabel)}
      </span>
    );
  }

  return (
    <span className={cls(styles.payment_status, styles.expires_at_status, className)}>
      {t(runningLabel)}: {countdown}
    </span>
  );
}
